module.exports = __webpack_public_path__ + "static/media/chinese cabbage.d461f64a.jpg";